/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_ParticipantTask_UpComingEventsDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_UpComingEventsDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_UpComingEventsResponseDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_UpComingEventsResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantUpcomingEventsService {

    /**
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_UpComingEventsDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDashboardParticipantUpcomingEvents(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_ParticipantTask_UpComingEventsDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/dashboard/participant-upcoming-events',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_UpComingEventsResponseDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDashboardParticipantUpcomingEventsSummary(): CancelablePromise<Wealthlane_AwardService_Dtos_ParticipantTask_UpComingEventsResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/dashboard/participant-upcoming-events-summary',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
